<template>
    <section>
        <div class="py-6 sm:py-8">
            <div class="relative sm:py-16">
                <div
                    class="
                        mx-auto
                        max-w-md
                        px-4
                        sm:max-w-3xl sm:px-6
                        lg:max-w-7xl lg:px-8
                    "
                >
                    <logo-nl
                        @click="dashboard()"
                        height="h-64  h-64
                            my-4
                            mx-auto
                            transform
                            hover:scale-110
                            transition
                            duration-500
                            ease-in-out
                            cursor-pointer"
                        class="
                            h-64
                            my-4
                            mx-auto
                            transform
                            hover:scale-110
                            transition
                            duration-500
                            ease-in-out
                            cursor-pointer
                        "
                    ></logo-nl>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    mounted() {},
    methods: {
        dashboard() {
            this.$router.push("/dashboard");
        },
    },
};
</script>
